import { useCallback } from "react";
import Text from "../Base/Text";
import View from "../Base/View";
import util from "../../utils/util";
import Block from "../Base/Block";
import Productinfoinorder from "../ProductInfoInOrder";
import './index.scss'

const AfterListItem = (prop: {
    orderInfo: any,
    onRequestShowRefundResult?: (orderInfo: any) => void
}) => {

    const { orderInfo } = prop;

    const _viewReturnRequestResult = useCallback(() => {
        util.navigateTo(
            '/aftersale/detail?isrmmp=1&hidemenu=1&internal=1&id=' + orderInfo.Id
        )
    }, [orderInfo])

    const _onProductListClick = useCallback(() => {
        if (orderInfo.OrderCancelRequestStatusId != 0) {
            if (orderInfo.Id > 0)
                util.navigateTo(
                    '/order/order?isrmmp=1&hidemenu=1&id=' + orderInfo.Id
                )
        } else {
            _viewReturnRequestResult()
        }
    }, [orderInfo])

    const refundOrder = useCallback(() => {
        if (prop.onRequestShowRefundResult)
            prop.onRequestShowRefundResult(orderInfo)
    }, [orderInfo])

    return <View className="after-list-item">
        <View
            className="order-list-item-header flex-conainer"
            onClick={_onProductListClick}
        >
            {orderInfo.OrderCancelRequestStatusId != 0 ? (
                <Text className="flex-grow">
                    {'订单号: ' + orderInfo.CustomOrderNumber}
                </Text>
            ) : (
                <Text className="flex-grow">
                    {'售后编号: ' + orderInfo.CustomNumber}
                </Text>
            )}
            {/*  <text wx:if="{{orderInfo.OrderStatusId==1 0}}" class="left-time">{{orderInfo.leftTimeStr}}</text>  */}
            {/*  <text wx:else class="order-status">{{orderInfo.OrderStatus}}</text>  */}
        </View>
        {/*  购买商品信息  */}
        <View onClick={_onProductListClick}>
            {orderInfo.Items.map((productInfo: any, index: number) => {
                return (
                    <Block>
                        <Productinfoinorder
                            productInfo={productInfo}
                            orderInfo={orderInfo}
                            showBottomBorder={index != orderInfo.Items.length - 1}
                        //   onRequestOpenShipmentDialog={()=>{
                        //     _openShipmentListDialog()
                        //   }}
                        ></Productinfoinorder>
                    </Block>
                )
            })}
        </View>
        {/*  查看进度、结果按钮  */}
        <View className="flex-conainer">
            {orderInfo.OrderCancelRequestStatusId != 0 ? (
                <Block>
                    <View className="flex-grow order-status">
                        {orderInfo.OrderCancelRequestStatus}
                    </View>
                    <View className="flex-fix refund-btn" onClick={refundOrder}>
                        {orderInfo.OrderCancelRequestStatusId == 1
                            ? '查看进度'
                            : '查看结果'}
                    </View>
                    {/*  <refundRequestDialog order-info="{{orderInfo}}">
        
                
        
              </refundRequestDialog>  */}
                </Block>
            ) : (
                <Block>
                    <View className="flex-grow order-status">
                        {orderInfo.ReturnRequestStatus}
                    </View>
                    <View
                        className="flex-fix refund-btn"
                        onClick={_viewReturnRequestResult}
                    >
                        {orderInfo.ReturnRequestStatusId == 1 ? '查看进度' : '查看结果'}
                    </View>
                </Block>
            )}
            {/* ="{{orderInfo.ReturnRequestStatusId !=0 }}"  */}
        </View>
    </View>
}

export default AfterListItem;